import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MorningMeetingService {
  private apiUrl = 'https://api.example.com/morning-meeting';

  constructor(private http: HttpClient) {}

  submitMeetingUpdate(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/submit`, data);
  }
}